import { LoadingContainer } from 'components/loadingContainer'
import { useCurrentAccount } from 'hooks/admin/useAuth'
import { Navigate, Outlet } from 'react-router-dom'
import { UserRole } from 'types/Organization'

export const ProtectedRouteSA = () => {
    const { currentAccount, isLoadingCurrentAccount } = useCurrentAccount()

    return (
        <LoadingContainer isLoading={isLoadingCurrentAccount} error={null}>
            {currentAccount && currentAccount.role === UserRole.superAdmin ? <Outlet /> : <Navigate to="/login" />}
        </LoadingContainer>
    )
}
